import { Auth } from "aws-amplify";
import axios from 'axios';
import { store } from "../";
import { SessionExpiredAction } from "../store/AppStore";

export interface callApiResult {
    success: boolean;
    data?: any;
    error?: any
    url?:string
};

const getToken = async () => {
    let token = "";
    try {
        // const session = await Auth.currentSession()
        token = "token"// session.getIdToken().getJwtToken()
    } catch (error) {
        store.dispatch({
            type: "SESSION_EXPIRED",
        } as SessionExpiredAction);
    }
    return token;
};

export const post = async (url: string, params: object | null) => {
    const token = await getToken();

    try {
        const res = await axios.post(`${process.env.REACT_APP_APIGW_URL}${url}`, params, { headers: { 'Authorization': token } })
        return {
            success: res.status === 200,
            data: res.data,
        } as callApiResult;
    } catch (err) {
        return {
            success: false,
            data: null,
            error: err,
        } as callApiResult;
    }
};

export const getAdmin = async (password: string) => {
    const token = await getToken();
    const getAdminUrl = "/user/get-admin";
    const params = {password}
    try {
        const res = await axios.post(`${process.env.REACT_APP_APIGW_URL}${getAdminUrl}`, params, { headers: { 'Authorization': token } })
        return {
            success: res.status === 200,
            data: res.data,
        } as callApiResult;
    } catch (err) {
        return {
            success: false,
            data: null,
            error: err,
        } as callApiResult;
    }
};
// #endregion
